import WanderuErrorBoundary from './WanderuErrorBoundary';

export default WanderuErrorBoundary;
